import { render, staticRenderFns } from "./close-circle.vue?vue&type=template&id=08340416&"
import script from "./close-circle.vue?vue&type=script&lang=js&"
export * from "./close-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08340416')) {
      api.createRecord('08340416', component.options)
    } else {
      api.reload('08340416', component.options)
    }
    module.hot.accept("./close-circle.vue?vue&type=template&id=08340416&", function () {
      api.rerender('08340416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/close-circle.vue"
export default component.exports